export default {
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 100
    }
  },
  methods: {
    handleSearch () {
      this.currentPage = 1
      this.getPageList()
    },
    //  分页
    handlePageChange (index) {
      this.currentPage = index
      this.getPageList()
    },
    handlePageSizeChange (index) {
      this.pageSize = index
      this.currentPage = 1
      this.getPageList()
    }
  }
}
